import React, { useMemo, useState } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Exportedreports.scss";
import { useTable, usePagination } from "react-table";
import fakeData from "./../../utils/dummyData/ExportReport.json";
import { faArrowDown , faPrint ,faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Table from "../../components/Table";

function Exportedreports() {
    const [activeRowIndex, setActiveRowIndex] = useState(-1);

    const columns = useMemo(
        () => [
            {
                Header: "Report Name",
                accessor: "ReportName",
            },
            {
                Header: "Description",
                accessor: "Description",
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({ row }) => {
                    return <button className="showmore" onClick={() => { setActiveRowIndex(row.index) }}><FontAwesomeIcon icon={faArrowDown} /></button>
                },
            },
            {
                Header: "Date Created",
                accessor: "DateCreated",
            },
            {
                Header: "Date Modified",
                accessor: "DateModified",
            },
            {
                Header: "",
                accessor: "dow",
                Cell: ({ cell: { value } }) => {
                   return <button className="faicon" onClick={() => {}}><img src="/Images/logo/download.png"/></button>
                },
            },
            {
                Header: "",
                accessor: "pri",
                Cell: ({ cell: { value } }) => {
                   return <button className="faicon" onClick={() => { }}><FontAwesomeIcon icon={faPrint} /></button>
                },
            },
            {
                Header: "",
                accessor: "mes",
                Cell: ({ cell: { value } }) => {
                   return <button className="faicon" onClick={() => {}}><FontAwesomeIcon icon={faEnvelope} /></button>
                },
            }
        ],
        []
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow
    } = useTable({ columns, data: fakeData || [] }, usePagination);
    return (
        <>
            <HeaderComponent title="Exported Reports" />
            <div className="ExportedreportsPage">
                <div className="container-fluid Exportedreportscontainer">
                    <div className="col-lg-10 col-sm-12 ">
                        <Table
                            headerGroups={headerGroups}
                            page={page}
                            prepareRow={prepareRow}
                            getTableProps={getTableProps}
                            getTableBodyProps={getTableBodyProps}
                            activeRowIndex={activeRowIndex}
                            setActiveRowIndex={setActiveRowIndex}
                        />
                    </div>
                    <div className="col-lg-2 col-sm-12 "></div>
                </div>
            </div>
        </>
    );
}
export default Exportedreports;